/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ClassroomdisciplineClassModulesMutationRequest,
  PostApiV1ClassroomdisciplineClassModulesMutationResponse,
  PostApiV1ClassroomdisciplineClassModules400,
  PostApiV1ClassroomdisciplineClassModules401,
  PostApiV1ClassroomdisciplineClassModules500,
} from "../../types/classPlanningClassModuleController/PostApiV1ClassroomdisciplineClassModules.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ClassroomdisciplineClassModules } from "../../clients/classPlanningClassModuleController/postApiV1ClassroomdisciplineClassModules.ts";

export const postApiV1ClassroomdisciplineClassModulesMutationKey = () =>
  [{ url: "/api/v1/classroomdiscipline/class-modules" }] as const;

export type PostApiV1ClassroomdisciplineClassModulesMutationKey = ReturnType<
  typeof postApiV1ClassroomdisciplineClassModulesMutationKey
>;

export function postApiV1ClassroomdisciplineClassModulesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1ClassroomdisciplineClassModulesMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1ClassroomdisciplineClassModulesMutationKey();
  return mutationOptions<
    PostApiV1ClassroomdisciplineClassModulesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ClassroomdisciplineClassModules400
      | PostApiV1ClassroomdisciplineClassModules401
      | PostApiV1ClassroomdisciplineClassModules500
    >,
    { data?: PostApiV1ClassroomdisciplineClassModulesMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1ClassroomdisciplineClassModules(data, config);
    },
  });
}

/**
 * @description Cria o Módulo, vincula Turmas, persiste as Disciplinas/recorrências e gera as Aulas (Planejado). **(Requer Authorization para autenticação)**
 * @summary Criar Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/class-modules}
 */
export function usePostApiV1ClassroomdisciplineClassModules<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ClassroomdisciplineClassModulesMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ClassroomdisciplineClassModules400
        | PostApiV1ClassroomdisciplineClassModules401
        | PostApiV1ClassroomdisciplineClassModules500
      >,
      { data?: PostApiV1ClassroomdisciplineClassModulesMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1ClassroomdisciplineClassModulesMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1ClassroomdisciplineClassModulesMutationKey();

  const baseOptions = postApiV1ClassroomdisciplineClassModulesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ClassroomdisciplineClassModulesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ClassroomdisciplineClassModules400
      | PostApiV1ClassroomdisciplineClassModules401
      | PostApiV1ClassroomdisciplineClassModules500
    >,
    { data?: PostApiV1ClassroomdisciplineClassModulesMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1ClassroomdisciplineClassModulesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ClassroomdisciplineClassModules400
      | PostApiV1ClassroomdisciplineClassModules401
      | PostApiV1ClassroomdisciplineClassModules500
    >,
    { data?: PostApiV1ClassroomdisciplineClassModulesMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ClassroomdisciplineClassModulesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ClassroomdisciplineClassModules400
      | PostApiV1ClassroomdisciplineClassModules401
      | PostApiV1ClassroomdisciplineClassModules500
    >,
    { data?: PostApiV1ClassroomdisciplineClassModulesMutationRequest },
    TContext
  >;
}
